var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-md-7 border rounded-3"},[_c('paylasim-yap'),_vm._l((5),function(i){return _c('paylasim-card',{key:i})})],2),_c('sidefix')],1)}
var staticRenderFns = []

export { render, staticRenderFns }